module.exports = __webpack_public_path__ + "static/media/icon-video-download.908fac12.svg";